import React, { Component } from 'react';
import { CharacterComponent } from '../CharacterComponent';
import { LeaguePlayerComponent } from '../LeaguePlayerComponent';
import ActiveSelectableButton from '../elements/ActiveSelectableButton';
import EmptyMatchmakingTabComponent from '../elements/EmptyMatchmakingTabComponent';

export default function RankedSlotSelections(props) {
	const { pendingSlot, selectedSlot, slots, changeRankedSlot } = props;
	const expanded = true;
	if(!slots) {
		return null;
	}
	const slotNumberToUse = pendingSlot || (!pendingSlot && selectedSlot);
	const mainSlotToShow = slots.find((slot) => {
		return slot.slot === slotNumberToUse;
	});
	return (
		<div className='ranked_slots'>
			{!expanded &&
			<div className='flex flex-column flex-space-between'>
				<div className=''>
					<a
						target='_blank'
						href='https://www.smashladder.com/guides/view/27d4/ranked-slots-faq' className='hint'>
						{' '}
						(Play Ranked Without Affecting Previous Stats)
					</a>
				</div>
				<div className=''>
					<ActiveSelectableButton
						onClick={expandRankedSlotView}
					>
						Change Slot
					</ActiveSelectableButton>
				</div>
				<div className='form-group flex flex-center flex-row'>
					<div className='currently_using'>Currently Using Ranked Slot{' '}
						<span className='emphasized_bright'>{mainSlotToShow.slot}</span>
					</div>
					{mainSlotToShow.characters.length > 0 &&
					<div>
						{' '}
						{mainSlotToShow.characters.map((character) => (
							<CharacterComponent
								key={character.id}
								character={character}
							/>
						))}
					</div>
					}
				</div>

			</div>
			}
			{expanded &&
			<div className='radio_buttons ranked_slot_selectors active'>
				{slots.map((slot) => {
					return (
						<RankedSlotSelection
							changeRankedSlot={changeRankedSlot}
							key={slot.slot}
							slot={slot}
							isSelected={pendingSlot === slot.slot || (!pendingSlot && selectedSlot === slot.slot)}
						/>
					);
				})}
			</div>
			}
		</div>
	);
}

class RankedSlotSelection extends Component {
	constructor(props) {
		super(props);
		const { changeRankedSlot, slot } = this.props;
		this.changeRankedSlot = changeRankedSlot.bind(null, slot);
	}

	render() {
		const { isSelected, slot } = this.props;
		const hasRequirements = slot.requirements && slot.requirements.length > 0 && !isSelected;
		return (
			<div key={slot.slot}
			     className={`radio_button ${hasRequirements ? 'requires_matches' : ''}`}>
				<div className='buttons'>
					<ActiveSelectableButton
						onClick={this.changeRankedSlot}
						selected
						glow={isSelected}
						data-input_name='selected_stat' type='button'
						className='button btn deselectable '>
						<span className=''>Ranked Slot {slot.slot}</span>
						{hasRequirements &&
						<div className='fancy'>
							<div className='requirement requires_matches'>
								{hasRequirements && slot.requirements.map((requirement) => {
									return (
										<div key={requirement.reason_description}>
											{requirement.reason_description}
										</div>
									);
								})}
							</div>
						</div>
						}
						{!hasRequirements &&
						<React.Fragment>
							<div className='fancy'>
								{slot.characters.map((character) => (
									<CharacterComponent
										key={character.id}
										character={character}
									/>
								))}
								<div className='tier'>
									<LeaguePlayerComponent
										league={slot.league}
										hidePoints
									/>
								</div>
							</div>
						</React.Fragment>
						}
					</ActiveSelectableButton>
				</div>
			</div>
		);
	}
}